import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGatewayDataQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type UpdateGatewayDataQuery = { __typename?: 'Query', gateways?: { __typename?: 'GatewayList', items: Array<{ __typename?: 'Gateway', numberId: number, displayName: string, sipUser: string, sipPassword: string, outgoingCallBarringOperator?: any | null, enabled: boolean, callbackNumberId?: number | null, callbackType: Types.CallbackType, multipleCallsNumber: number, number?: { __typename?: 'Number', nonPaymentBlockingType: Types.NonPaymentBlockingType, domain: { __typename?: 'Domain', outgoingCallBarringOperator?: any | null, outgoingCallBarringAdmin?: any | null } } | null } | null> } | null };


export const UpdateGatewayDataDocument = gql`
    query UpdateGatewayData($id: Int!) {
  gateways(id: $id) {
    items {
      numberId
      displayName
      sipUser
      sipPassword
      outgoingCallBarringOperator
      enabled
      callbackNumberId
      callbackType
      multipleCallsNumber
      number {
        nonPaymentBlockingType
        domain {
          outgoingCallBarringOperator
          outgoingCallBarringAdmin
        }
      }
    }
  }
}
    `;

/**
 * __useUpdateGatewayDataQuery__
 *
 * To run a query within a React component, call `useUpdateGatewayDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateGatewayDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateGatewayDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateGatewayDataQuery(baseOptions: Apollo.QueryHookOptions<UpdateGatewayDataQuery, UpdateGatewayDataQueryVariables> & ({ variables: UpdateGatewayDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateGatewayDataQuery, UpdateGatewayDataQueryVariables>(UpdateGatewayDataDocument, options);
      }
export function useUpdateGatewayDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateGatewayDataQuery, UpdateGatewayDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateGatewayDataQuery, UpdateGatewayDataQueryVariables>(UpdateGatewayDataDocument, options);
        }
export function useUpdateGatewayDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateGatewayDataQuery, UpdateGatewayDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateGatewayDataQuery, UpdateGatewayDataQueryVariables>(UpdateGatewayDataDocument, options);
        }
export type UpdateGatewayDataQueryHookResult = ReturnType<typeof useUpdateGatewayDataQuery>;
export type UpdateGatewayDataLazyQueryHookResult = ReturnType<typeof useUpdateGatewayDataLazyQuery>;
export type UpdateGatewayDataSuspenseQueryHookResult = ReturnType<typeof useUpdateGatewayDataSuspenseQuery>;
export type UpdateGatewayDataQueryResult = Apollo.QueryResult<UpdateGatewayDataQuery, UpdateGatewayDataQueryVariables>;